module.exports = __webpack_public_path__ + "static/img/top5.7463dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top5.png
// module id = 6Oav
// module chunks = 1